module.exports = __webpack_public_path__ + "img/Newbie_Dagger_03_Classic.f5fdca14.png";